import { render, staticRenderFns } from "./DesignShopTileList.vue?vue&type=template&id=5d5d32f5&scoped=true&"
import script from "./DesignShopTileList.vue?vue&type=script&lang=js&"
export * from "./DesignShopTileList.vue?vue&type=script&lang=js&"
import style0 from "./DesignShopTileList.vue?vue&type=style&index=0&id=5d5d32f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5d32f5",
  null
  
)

export default component.exports